import { render, staticRenderFns } from "./PlbscfTableRow.vue?vue&type=template&id=dd11a2b0&scoped=true&"
import script from "./PlbscfTableRow.ts?vue&type=script&lang=ts&"
export * from "./PlbscfTableRow.ts?vue&type=script&lang=ts&"
import style0 from "./PlbscfTableRow.css?vue&type=style&index=0&id=dd11a2b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd11a2b0",
  null
  
)

export default component.exports